import {
  SessionServerSelectors,
  SessionSiteSelectors,
  SessionUserSelectors
} from '~selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { SiteRolesUtil } from '../../userManagement/services/resources/SiteRolesUtil';
import { setExtractRefreshPriority } from '../actions/SetExtractRefreshPriorityAction';

export const SetExtractRefreshPriorityEntityAction: IEntityAction<IExtractTaskInfo, {}> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: isVisible,
  isClickable: () => true,
  createReduxAction: setExtractRefreshPriority
};

function isVisible(tasks: IExtractTaskInfo[], state: AppState): boolean {
  return (SessionUserSelectors.isSessionServerAdmin(state) || SiteRolesUtil.isSiteAdmin(SessionSiteSelectors.siteRole(state)))
    && !SessionServerSelectors.ignoreExtractTaskPriority(state);
}
